// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.vrmodel.RentalManagerUserPropertyVrModelWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels,
  RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ListingAlias,
  UserPropertyVrModelGetAllVrModelsResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface GetAllVrModelsParams {
  listingAlias: ListingAlias;
}

export type RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_Options = UseQueryOptions<
  UserPropertyVrModelGetAllVrModelsResponseWebDto,
  unknown,
  UserPropertyVrModelGetAllVrModelsResponseWebDto,
  readonly [string, GetAllVrModelsParams]
>;

const RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_GetKey = (getParams: GetAllVrModelsParams) =>
  [RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_Path, getParams] as const;

export const RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_queryOptions = (
  getParams: GetAllVrModelsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Retrieve all vr models
 */
export const useRentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels = (
  getParams: GetAllVrModelsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels.getKey =
  RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_GetKey;
